import { extendTheme } from '@chakra-ui/react';

export const theme = extendTheme({
 
  margin: {
    
  },
  fonts: {
    heading: `'Inter', sans-serif`,
    body: `'Inter', sans-serif`,
  },
  colors:{
    white: '#E5E1DC',
    black: '#212121'
  },
  styles: {
    global:{
      body:{
        fontSize: '18px',
        letterSpacing: '.06',
        lineHeight: '150%',
        fontWeight: '400'
      },
    }
  }
});